import { FC } from 'react';
import { IconName } from '@shinetools/sunshine-icons';

import SunshineCard, { SunshineCardProps } from 'components/_core/SunshineCard';
import SunshineSquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';

type CreateCardProps = {
  onClick: () => void;
  icon: IconName;
  title: string;
  description: string;
} & SunshineCardProps;

const CreateCard: FC<CreateCardProps> = ({
  description,
  icon,
  onClick,
  title,
  ...cardProps
}) => (
  <SunshineCard onClick={() => onClick()} title={title} {...cardProps}>
    <SunshineCard.Slot name="aside">
      <SunshineSquircleIcon name={icon} />
    </SunshineCard.Slot>

    <Text fontWeight="weight-400" size="sm">
      {description}
    </Text>

    <SunshineCard.Slot name="action">
      <SunshineCard.SunshineIcon name="chevron-right" />
    </SunshineCard.Slot>
  </SunshineCard>
);

export default CreateCard;
